import ApiService from "../../commons/services/ApiService";
import CompanyAPI from "../company/CompanyAPI";

const apiService = new ApiService();

export default class CashRegisterAPI {
  private registerUri = "/v1/cash-registers";
  private openingUri = "/v1/cash-register-openings";

  private companyId() {
    return new CompanyAPI().getCompanyManagment().id;
  }

  findRegisters = async () =>
    apiService.get(`${this.registerUri}?companyId=${this.companyId()}`);

  createRegister = async (data: any) =>
    apiService.post(`${this.registerUri}?companyId=${this.companyId()}`, data);

  findOpenings = async () =>
    apiService.get(`${this.openingUri}?companyId=${this.companyId()}`);

  open = async (data: any) =>
    apiService.post(`${this.openingUri}?companyId=${this.companyId()}`, data);

  withdraw = async (openingId: number, data: any) =>
    apiService.post(
      `${this.openingUri}/${openingId}/withdrawals?companyId=${this.companyId()}`,
      data
    );

  closingSummary = async (openingId: number) =>
    apiService.get(
      `${this.openingUri}/${openingId}/closing-summary?companyId=${this.companyId()}`
    );

  close = async (
    openingId: number,
    countedBalance: number,
    description?: string | null
  ) => {
    const body = {
      countedBalance,
      description: description || null,
    };

    return apiService.patch(
      `${this.openingUri}/${openingId}/close?companyId=${this.companyId()}`,
      body,
      { headers: { "Content-Type": "application/json" } }
    );
  };

  movements = async (openingId: number, page = 0, limit = 50) =>
    apiService.get(
      `${this.openingUri}/${openingId}/movements?companyId=${this.companyId()}&page=${page}&limit=${limit}`
    );
}
